import React, { useState, useEffect, useCallback } from 'react';
import HomeLayout from '../Layouts/homeLayout';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { getAddressBook, saveAddressBook, deleteAddressBook, updateAddressBook } from '../../actions/userActions';
import LoadingView from '../Loader/LoadingView';
import AddAddressBook from './components/add';
import { toast } from 'react-toastify';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmAlert from '../common/confirmAlert';
import NoData from '../common/noData';
import './styles.css';

const AddressBook = () =>
{
	const [ open, setOpen ] = useState(false);
	const [ list, setList ] = useState({ loading: false, data: [] });
	const [ deleteId, setDeleteId ] = useState(null);
	const [ editObj, setEditObj ] = useState(null);

	const handleOpen = () => setOpen(true);

	const getData = useCallback(() =>
	{
		setList((prevState) => { return { ...prevState, loading: true }; });
		getAddressBook().then((res) =>
		{
			// eslint-disable-next-line no-console
			// console.log('res ==== ', res);
			if (res?.data?.status)
			{
				setList({ loading: false, data: [ ...res.data.data ] });
			}
			else
			{
				setList({ loading: false, data: [] });
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line no-console
				console.log('err ==== ', err);
				setList({ loading: false, data: [] });
			});
	}, []);

	useEffect(() =>
	{
		getData();
	}, [ getData ]);

	const handleDelete = () =>
	{
		if (deleteId !== null)
		{
			setList((prevState) => { return { ...prevState, loading: true }; });
			deleteAddressBook({ id: deleteId }).then((res) =>
			{
				// eslint-disable-next-line no-console
				// console.log('res ==== ', res);
				if (res && res.status)
				{
					toast.success('Deleted successfully');
					setDeleteId(null);
					getData();
				}
				else
				{
					toast.error('Internal server error, Please try again');
					setList((prevState) => { return { ...prevState, loading: false }; });
				}
			})
				.catch((err) =>
				{
					// eslint-disable-next-line no-console
					console.log('err ==== ', err);
					toast.error('Internal server error, Please try again');
					setList((prevState) => { return { ...prevState, loading: false }; });
				});
		}
	};

	const handleSave = (formData) =>
	{
		setList((prevState) => { return { ...prevState, loading: true }; });
		saveAddressBook(formData).then((res) =>
		{
			// eslint-disable-next-line no-console
			// console.log('res ==== ', res);
			if (res?.data?.status)
			{
				setOpen(false);
				toast.success(res.data.message);
				getData();
			}
			else
			{
				toast.error(res.data.message);
				setList((prevState) => { return { ...prevState, loading: true }; });
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line no-console
				console.log('err ==== ', err);
				toast.error('Internal server error, Please try again');
				setList((prevState) => { return { ...prevState, loading: true }; });
			});
	};

	const handleAddressClose = () =>
	{
		setOpen(false);
		setEditObj(null);
	};

	const handleUpdate = (id, obj) =>
	{
		setList((prevState) => { return { ...prevState, loading: true }; });
		obj['id'] = id;
		updateAddressBook(obj).then((res) =>
		{
			// eslint-disable-next-line no-console
			// console.log('res ==== ', res);
			if (res && res.status)
			{
				setEditObj(null);
				toast.success(res.message);
				getData();
			}
			else
			{
				toast.error(res.message);
				setList((prevState) => { return { ...prevState, loading: false }; });
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line no-console
				console.log('err ==== ', err);
				toast.error('Internal server error, Please try again');
				setList((prevState) => { return { ...prevState, loading: false }; });
			});
	};

	return (
		<div className='flexCol pdngXS'>
			<div className='rightButton pdngXS'><Button variant='contained' onClick={handleOpen}>Add Contact</Button></div>
			{list?.loading && <LoadingView />}
			<TableContainer component={Paper} className='pdngXS'>
				{list.data.length > 0 ?
					<Table sx={{ minWidth: 650 }} aria-label='simple table'>
						<TableHead className='tableHeader'>
							<TableRow>
								<TableCell>Name</TableCell>
								<TableCell>Email</TableCell>
								<TableCell align='right'>Edit</TableCell>
								<TableCell align='right'>Delete</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{list.data && list.data.map((row) => (
								<TableRow
									key={row._id}
									sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
								>
									<TableCell component='th' scope='row'>
										{row.name}
									</TableCell>
									<TableCell>{row.email}</TableCell>
									<TableCell align='right' onClick={() => setEditObj(row)}><EditIcon title='edit'/></TableCell>
									<TableCell align='right' onClick={() => setDeleteId(row._id)}><DeleteIcon title='delete'/></TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
					: <NoData nodata='No Contacts'/>
				}
			</TableContainer>
			{(open || editObj !== null) &&
			<AddAddressBook
				open={open || editObj !== null}
				data={editObj}
				handleClose={handleAddressClose}
				handleSave={handleSave}
				handleUpdate={handleUpdate}
			/>}
			{deleteId !== null &&
			<ConfirmAlert
				open={deleteId !== null}
				content='Do you really want to delete the Address?'
				handleOk={handleDelete}
				handleCancel={() => setDeleteId(null)}
			/>
			}
		</div>
	);
};

export default HomeLayout(AddressBook);